/**
 * PWA (Progressive Web App) detection utilities
 * Based on logic from AddToHomeFloatButton and LoginPage
 */

/**
 * Check if the app is currently running as an installed PWA
 * @returns {boolean} True if running as PWA, false otherwise
 */
export const isPWAInstalled = () => {
    // iOS detection: Check if running in standalone mode
    const iOSIsInstalled = window.navigator.standalone === true;
    
    // Android/Desktop detection: Check display-mode
    const androidIsInstalled = window.matchMedia && window.matchMedia('(display-mode: standalone)').matches;
    
    return iOSIsInstalled || androidIsInstalled;
};

/**
 * Check if PWA install should be hidden based on installation status
 * @returns {boolean} True if install UI should be hidden
 */
export const shouldHidePWAInstall = () => {
    return isPWAInstalled();
};